import {createContext} from "react";

export const ColorsContext = createContext({
    colors: {
        COLOR_BODY: '#ffffff',
        COLOR_HEADER: '#ffffff',
        COLOR_NAVBAR: '#ffffff'
    },
    setColors: ()=>{}
});